import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialogo-si-no',
  templateUrl: './dialogo-si-no.component.html',
  styleUrls: ['./dialogo-si-no.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DialogoSiNoComponent implements OnInit {

  constructor( public dialogRef: MatDialogRef<DialogoSiNoComponent>) { }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  onSiClick(): void {
    this.dialogRef.close(true);
  }
}





// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/table-items/dialogo-si-no/dialogo-si-no.component.ts